import React from "react";
import "../styles/article.css";

const Article = ({ title, imageUrl, link }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="article-card">
      <div className="article-content">
        <div className="article-title">{title}</div>
        <div className="article-image-wrapper">
          <img src={imageUrl} alt={title} className="article-image" />
        </div>
      </div>
    </a>
  );
};

export default Article;
